import { CirclesThree, HandCoins, House, MapPin } from '@phosphor-icons/react'

type ReasonTypeIconProps = {
    type: 'location' | 'asset' | 'rent' | 'other'
    size?: `${number}px`
    color?: string
}

export const ReasonIcon = ({ type, size, color }: ReasonTypeIconProps) => {
    switch (type) {
        case 'location':
            return <MapPin weight="bold" size={size} color={color} />
        case 'asset':
            return <House weight="bold" size={size} color={color} />
        case 'rent':
            return <HandCoins weight="bold" size={size} color={color} />
        case 'other':
            return <CirclesThree weight="bold" size={size} color={color} />
    }
}
